import * as ko from "knockout";
import * as moment from "moment";
import * as Clipboard from "clipboard";
import * as Chart from "chart.js";
import { KnockoutExtensions } from "./knockoutextensions";

/**
 * Executes the MDL upgradeElement method on the bound element. Useful for templates where the MDL
 * wiring will not execute automatically.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).upgradeElement = {
    init(element: HTMLElement) {
        componentHandler.upgradeElement(element);
    }
};

/**
 * Associates a rendering function with an element set up for jQuery UI AutoComplete.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).autoCompleteRenderer = {
    // tslint:disable-next-line
    init(element: HTMLElement, valueAccessor: any) {
        // tslint:disable-next-line
        ($(element).autocomplete("instance") as any)._renderItem = valueAccessor();
    }
};

/**
 * Configures an input element as an MDL text field.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).debug = {
    // tslint:disable-next-line
    init(element: HTMLElement, valueAccessor: any) {
            console.log('Knockoutbinding:');
            console.log(element);
            console.log(ko.toJS(valueAccessor()));
        }
};

/**
 * Configures an input element as an MDL text field.
 */
// tslint:disable-next-line
ko.bindingHandlers.selected = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var selected = ko.utils.unwrapObservable(valueAccessor());
        if (selected) element.select();
    }
};

/**
 * Configures an input element as an MDL text field.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).mdlInput = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $el = $(element);
        const $enclosingDiv = $("<div class='input-wrapper'>").insertAfter($el);
        const $label = $("<label>");
        const params = valueAccessor();

        const allBindings = allBindingsAccessor();

        $el.attr("id", params.id);
        $label.attr("for", params.id).text(params.label);
        $el.addClass("mdl-textfield__input");
        $label.addClass("mdl-textfield__label");

        const isFloating = (params.isFloatingLabel == null || params.isFloatingLabel !== false);
        const isNumber = (params.isNumber != null && params.isNumber === true);
        const isFullWidth = (params.isFullWidth != null && params.isFullWidth);
        const isLarge = (params.isLarge != null && params.isLarge);

        if (params.containerClass) {
            $enclosingDiv.addClass(params.containerClass);
        }

        $enclosingDiv.addClass("mdl-textfield mdl-js-textfield");
        if (isFloating) {
            $enclosingDiv.addClass("mdl-textfield--floating-label");
        }

        if (isNumber) {
            //$el.attr("pattern", "^-?[0-9]*(\.[0-9]+)?$");
            $enclosingDiv.addClass("mdl-textfield--numeric");
        }

        if (isFullWidth) {
            $enclosingDiv.addClass("mdl-textfield--fullwidth");
        }

        if (isLarge) {
            $enclosingDiv.addClass("mdl-textfield--large");
        }

        $enclosingDiv.append($el).append($label);

        if (params.visible != null) {
            ko.applyBindingsToNode($enclosingDiv[0], () => {
                const value = valueAccessor();
                return { visible: value.visible };
            });
        }

        ko.applyBindingsToNode($el.get(0), { valueUpdate: "keyup" });

        // tslint:disable-next-line
        componentHandler.upgradeElement(($enclosingDiv.get(0) as any) as HTMLElement);
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any) => {
        const params = allBindingsAccessor();
        const value = params.value != null
            ? params.value() : params.textInput != null
                ? params.textInput() : params.textInputWithDefault != null
                    ? params.textInputWithDefault() : null;
        const isDisabled = $(element).attr("disabled") != null;
        $(element).parent().toggleClass("is-disabled", isDisabled);
        $(element).parent()[value != null ? "addClass" : "removeClass"]("is-dirty");
    }
};


/**
 * Configures a button element as an MDL menu button, by creating the associated menu instance from a template.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).mdlMenu = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $el = $(element);
        const params = valueAccessor();
        const baseId = $el.attr("id");
        const templateId = params.template;
        const position = params.position || "bottom-left";

        $el.addClass("mdl-button mdl-js-button mdl-button--icon");

        const $list = $(KnockoutExtensions.getTemplateByName(templateId))
            .addClass(`mdl-menu mdl-menu--${position} mdl-js-menu mdl-js-ripple-effect`)
            .attr("for", baseId);

        $el.after($list);

        ko.applyBindingsToDescendants(context, $list.get(0));

        // tslint:disable-next-line
        componentHandler.upgradeElement(($el.get(0) as any) as HTMLElement);
        // tslint:disable-next-line
        componentHandler.upgradeElement(($list.get(0) as any) as HTMLElement);

        return { 'controlsDescendantBindings': true };
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {
        ko.applyBindingsToDescendants(context, element);
    }
};

// tslint:disable-next-line
(ko.bindingHandlers as any).mdlExtMenu = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $el = $(element);
        const params = valueAccessor();
        const baseId = $el.attr("id");
        const templateId = params.template;
        const isInDialog = params.isInDialog;

        $el.addClass("mdl-button mdl-js-button mdl-button--primary action-button mdlext-js-menu-button action-button");

        const menuId = baseId + "-menu";
        const $list = $(KnockoutExtensions.getTemplateByName(templateId))
            .addClass("mdlext-menu")
            .attr("id", menuId);

        $el.after($list);

        ko.applyBindingsToDescendants(context, $list.get(0));

        // tslint:disable-next-line
        componentHandler.upgradeElement(($el.get(0) as any) as HTMLElement);
        // tslint:disable-next-line
        componentHandler.upgradeElement(($list.get(0) as any) as HTMLElement);

        if (isInDialog) {
            // To ensure that the list is visible when using mdl-extmenu on a dialog
            const $finalList = $("#" + menuId);
            $el.after($finalList);
        }

        return { 'controlsDescendantBindings': true };
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {
        ko.applyBindingsToDescendants(context, element);
    }
};


/**
 * Configures an element as an MDL dialog with bindings to the DialogViewModel type.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).mdlDialog = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $dialog = $(element).addClass("mdl-dialog");

        const $title = $("<h4/>")
            .addClass("mdl-dialog__title")
            .attr("data-bind", "text: title");
        $dialog.append($title);

        var $busyOverlay = $("<div/>")
            .addClass("busy-overlay")
            .attr("data-bind", "visible: isBusy");
        var $content = $("<div/>")
            .addClass("mdl-dialog__inner-content-container");
        if (data != null) {
            $content.html(data.content);
        }
        const $contentWrapper = $("<div/>")
            .addClass("mdl-dialog__content")
            .append($content)
            .append($busyOverlay);

        $dialog.append($contentWrapper);

        const $actions = $("<div/>")
            .addClass("mdl-dialog__actions")
            .attr("data-bind", "foreach: actions");

        const $actionButton = $("<button/>")
            .attr("type", "button")
            .addClass("mdl-button mdl-js-button mdl-button--primary")
            .attr("data-bind", "text: caption, click: action");

        $actions.append($actionButton);
        $dialog.append($actions);

        ko.applyBindingsToDescendants(context, $dialog.get(0));

        // tslint:disable-next-line
        componentHandler.upgradeElement(($dialog.get(0) as any) as HTMLElement);

        return { 'controlsDescendantBindings': true };
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {
        if (data != null) {
            const $contentDiv = $(".mdl-dialog__content .mdl-dialog__inner-content-container", element);
            $contentDiv.html(data.content);
            ko.applyBindingsToDescendants(context, $contentDiv.get(0));
        }
    }
};

/**
 * Configures an input element as an MDL checkbox.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).mdlCheckbox = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $el = $(element);
        const $enclosingLabel = $("<label class='input-wrapper'>").insertAfter($el);
        const $captionSpan = $("<span>");
        const params = valueAccessor();

        $el.attr("id", params.id);
        $el.addClass("mdl-checkbox__input");
        $enclosingLabel.attr("for", params.id);

        if (ko.isObservable(params.label)) {
            ko.applyBindingsToNode($enclosingLabel[0], { text: params.label });
        } else {
            $captionSpan.text(params.label);
        }

        $captionSpan.addClass("mdl-checkbox__label");
        $enclosingLabel.addClass("mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect").append($el).append($captionSpan);
        
        if (params.containerClass) {
            $enclosingLabel.addClass(params.containerClass);
        }

        if (params.visible) {
            ko.applyBindingsToNode($enclosingLabel[0], { visible: params.visible });
        }
        
        ko.bindingHandlers.checked.init(element, () => params.checked, allBindingsAccessor, data, context);
        
        // tslint:disable-next-line
        componentHandler.upgradeElement(($enclosingLabel[0] as any) as HTMLElement);

        if (params.isDisabledOverride === true) {
            $enclosingLabel.removeClass("is-disabled");
        }

        if (params.checked()) {
            $enclosingLabel.addClass("is-checked");
        }
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any) => {
        // mdl does not reflect the initial checked value, so we do that explicitly here
        const params = valueAccessor();
        const $enclosingLabel = $(element).parent("label");
        if (params.checked()) {
            $enclosingLabel.addClass("is-checked");
        }
        else {
            $enclosingLabel.removeClass("is-checked");
        }
        if (params.isDisabledOverride === false) {
            $enclosingLabel.addClass("is-disabled");
        }
        else if (params.isDisabledOverride === true) {
            $enclosingLabel.removeClass("is-disabled");
        }
    }
};

/**
 * Configures an input element as an MDL checkbox.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).mdlSwitch = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $el = $(element);
        const $enclosingLabel = $("<label class='input-wrapper'>").insertAfter($el);
        const $captionSpan = $("<span>");
        const params = valueAccessor();

        $el.attr("id", params.id);
        $el.addClass("mdl-switch__input");
        $enclosingLabel.attr("for", params.id);

        if (ko.isObservable(params.label)) {
            ko.applyBindingsToNode($captionSpan[0], { text: params.label });
        } else {
            $captionSpan.text(params.label);
        }

        $captionSpan.addClass("mdl-switch__label");
        $enclosingLabel.addClass("mdl-switch mdl-js-switch mdl-js-ripple-effect").append($el).append($captionSpan);

        if (params.containerClass) {
            $enclosingLabel.addClass(params.containerClass);
        }

        if (params.visible) {
            ko.applyBindingsToNode($enclosingLabel[0], { visible: params.visible });
        }

        ko.bindingHandlers.checked.init(element, () => params.checked, allBindingsAccessor, data, context);

        // tslint:disable-next-line
        componentHandler.upgradeElement(($enclosingLabel[0] as any) as HTMLElement);

        if (params.isDisabledOverride === true) {
            $enclosingLabel.removeClass("is-disabled");
        }

        if (params.checked()) {
            $enclosingLabel.addClass("is-checked");
        }
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any) => {
        // mdl does not reflect the initial checked value, so we do that explicitly here
        const params = valueAccessor();
        const $enclosingLabel = $(element).parent("label");
        if (params.checked()) {
            $enclosingLabel.addClass("is-checked");
        }
        else {
            $enclosingLabel.removeClass("is-checked");
        }
        if (params.isDisabledOverride === false) {
            $enclosingLabel.addClass("is-disabled");
        }
        else if (params.isDisabledOverride === true) {
            $enclosingLabel.removeClass("is-disabled");
        }
    }
};

/**
 * Configures an input element as an MDL radio button.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).mdlRadioButton = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, context: any) => {

        const $el = $(element);
        const $enclosingLabel = $("<label>").insertAfter($el);
        const $captionSpan = $("<span>");
        const params = valueAccessor();
        const allParams = allBindingsAccessor();

        $el.attr("id", params.id);
        $el.addClass("mdl-radio__button");
        $enclosingLabel.attr("for", params.id);

        if (ko.isObservable(params.label)) {
            ko.applyBindingsToNode($enclosingLabel[0], { text: params.label });
        } else {
            $captionSpan.text(params.label);
        }

        $captionSpan.addClass("mdl-radio__label");
        $enclosingLabel.addClass("mdl-radio mdl-js-radio mdl-js-ripple-effect").append($el).append($captionSpan);

        if (params.containerClass) {
            $enclosingLabel.addClass(params.containerClass);
        }

        if (params.visible) {
            ko.applyBindingsToNode($enclosingLabel[0], { visible: params.visible });
        }

        //ko.bindingHandlers.checked.init(element, valueAccessor, allBindingsAccessor, data, context);

        // tslint:disable-next-line
        componentHandler.upgradeElement(($enclosingLabel[0] as any) as HTMLElement);

        if (allParams.checked() === allParams.checkedValue) {
            $enclosingLabel.addClass("is-checked");
        }
    },
    // tslint:disable-next-line
    update: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any) => {
        // mdl does not reflect the initial checked value, so we do that explicitly here
        const allParams = allBindingsAccessor();
        const $enclosingLabel = $(element).parent("label");
        $enclosingLabel.toggleClass("is-checked", allParams.checked() === allParams.checkedValue);
        if (allParams.disable != null) {
            $enclosingLabel.toggleClass("is-disabled", ko.unwrap(allParams.disable));
        }
    }
};
/**
 * Validation extension to set a conditional required validation rule on an observable.
 */
// tslint:disable-next-line
(<any>ko.extenders).requiredOnlyIf = (target: any, makeRequired: () => boolean) => {
    target.HasError = ko.pureComputed(() => {
        const otherHasValue = makeRequired();
        const targetHasValue = !!target();

        return otherHasValue && !targetHasValue;
    });

    return target;
};

/**
 * Some default common ignore fields.
 */
ko.mapping.defaultOptions().ignore = ["parent", "errors"];

/**
 * Configures an input field to work with date values.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).date = {
    // https://disqus.com/home/discussion/jasonmitchellcom/binding_and_formatting_dates_using_knockout_and_moment_js/#comment-1374417079
    // tslint:disable-next-line
    init: (element: any, valueAccessor: any) => {
        ko.utils.registerEventHandler(element, "change", () => {
            const value = valueAccessor();
            if (element.value !== null && element.value !== undefined && element.value.length > 0) {
                value(element.value);
            }
            else {
                value("");
            }
        });
    },
    // tslint:disable-next-line
    update: (element: any, valueAccessor: any, allBindingsAccessor: any) => {
        const value = valueAccessor();
        const allBindings = allBindingsAccessor();
        const valueUnwrapped = ko.utils.unwrapObservable(value);

        // Date formats: http://momentjs.com/docs/#/displaying/format/
        const pattern = allBindings.format || "DD/MM/YYYY";

        let output = "-";
        if (valueUnwrapped !== null && valueUnwrapped !== undefined && valueUnwrapped.length > 0) {
            output = moment(valueUnwrapped).format(pattern);
        }

        if ($(element).is("input")) {
            $(element).val(output);
        } else {
            $(element).text(output);
        }
    }
};

/**
 * Binding handler that fires a method when the enter key is pressed.
 */
// tslint:disable-next-line
(ko.bindingHandlers as any).enterkey = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any) => {
        const callback = valueAccessor();
        $(element).keypress((event) => {
            const keyCode = (event.which ? event.which : event.keyCode);
            if (keyCode === 13) {
                callback.call(data);
                return false;
            }
            return true;
        });
    }
};

// tslint:disable-next-line
(ko.bindingHandlers as any).textInputWithDefault = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any, bindingContext: any) => {
        var property = valueAccessor();
        var value = (element as HTMLInputElement).value;
        if (property() == null) {
            property(value);
        }
        ko.bindingHandlers.textInput.init(element, valueAccessor, allBindingsAccessor, data, bindingContext);
    }
};

// tslint:disable-next-line
(ko.bindingHandlers as any).fadeVisible = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any) => {
        // Initially set the element to be instantly visible/hidden depending on the value
        var value = valueAccessor();
        $(element).toggle(ko.unwrap(value)); // Use "unwrapObservable" so we can handle values that may or may not be observable
    },
    // tslint:disable-next-line
    update: (element: any, valueAccessor: any, allBindingsAccessor: any) => {
        // Whenever the value subsequently changes, slowly fade the element in or out
        var value = valueAccessor();
        ko.unwrap(value) ? $(element).fadeIn() : $(element).fadeOut();
    }
};

// tslint:disable-next-line
(ko.bindingHandlers as any).lineClamp = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, data: any) => {
        // Initially set the element to be instantly visible/hidden depending on the value
        var value = ko.utils.unwrapObservable(valueAccessor());
        var maxHeight = value.maxHeight as number;
        // tslint:disable-next-line
        var valueUpdateTrigger = ko.utils.unwrapObservable(value.value);
        // tslint:disable-next-line
        var updateOn = ko.utils.unwrapObservable(value.updateOn) as any;
        $(element.parentElement).css("max-height", maxHeight);
        setTimeout(() => {
            KnockoutExtensions.applyLineClamp(element, maxHeight);
        }, 1);
    },
    // tslint:disable-next-line
    update: (element: any, valueAccessor: any, allBindingsAccessor: any) => {
        // Whenever the value subsequently changes, slowly fade the element in or out
        var value = ko.utils.unwrapObservable(valueAccessor());
        var maxHeight = value.maxHeight as number;
        // tslint:disable-next-line
        var valueUpdateTrigger = ko.utils.unwrapObservable(value.value);
        // tslint:disable-next-line
        var updateOn = ko.utils.unwrapObservable(value.updateOn) as any;
        $(element.parentElement).css("max-height", maxHeight);
        setTimeout(() => {
            KnockoutExtensions.applyLineClamp(element, maxHeight);
        }, 1);
    }
};

// tslint:disable-next-line
(ko.bindingHandlers as any).chart = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, viewModel: any) => {
        var allBindings = allBindingsAccessor();
        var chartBinding = allBindings.chart;
        var activeChart: Chart;
        var chartData: Chart.ChartConfiguration;

        var createChart = () => {
            var chartType = ko.unwrap(chartBinding.type);
            var data = ko.toJS(chartBinding.data);
            var options = ko.toJS(chartBinding.options);

            chartData = {
                type: chartType as Chart.ChartType,
                data: data as Chart.ChartData,
                options: options as Chart.ChartOptions
            };

            // tslint:disable-next-line
            activeChart = new Chart(($(element).get(0) as any) as HTMLCanvasElement, chartData);
        };

        var refreshChart = () => {
            chartData.data = ko.toJS(chartBinding.data);
            activeChart.update();
            activeChart.resize();
        };

        var subscribeToChanges = () => {
            ko.computed(function () {
                return ko.toJSON(chartBinding.data);
            }).subscribe(function () {
                refreshChart();
            });
        };

        createChart();
        
        if (chartBinding.options && chartBinding.options.observeChanges) {
            subscribeToChanges(); 
        }
    }
};

// tslint:disable-next-line
(ko.bindingHandlers as any).stopBinding = {
    // tslint:disable-next-line
    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, viewModel: any) => {
        return { controlsDescendantBindings: true };
    }
};

/**
 * One time knockout validation initialisation for MDL.
 */
ko.validation.init({
    errorMessageClass: "mdl-textfield__error",
    messageTemplate: "validation-error-template-html",
    decorateInputElement: true,
    errorElementClass: "is-invalid"
});

// tslint:disable-next-line
ko.validation.insertValidationMessage = element => {
    var $span = $("<span/>");
    $span.insertBefore(element.nextSibling as Element);

    //if ($(element).hasClass("error-before"))
    //    element.parentNode.insertBefore(span, element);
    //else
    //    element.parentNode.insertBefore(span, element.nextSibling);
    //return null as Element;
    return $span.get(0);
};

// tslint:disable-next-line
(ko.validation as any).makeBindingHandlerValidatable("textInputWithDefault");

/**
 * Enhance the validation functionality to add the validation markup to any input wrappers (mdl uses those extensively)
 */
var init = ko.bindingHandlers["validationCore"].init;
// tslint:disable-next-line
ko.bindingHandlers["validationCore"].init = (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, viewModel?: any, bindingContext?: KnockoutBindingContext) => {
    init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
    const config = ko.validation.utils.getConfigOptions(element);
    // if requested, add binding to decorate element
    if (config.decorateInputElement && ko.validation.utils.isValidatable(valueAccessor())) {
        const parent = $(element).parents(".input-wrapper");
        if (parent.length) {
            ko.applyBindingsToNode(parent[0], { validationElement: valueAccessor() });
        }
    }
};

//(ko.bindingHandlers as any).not = {
//    init: (element: HTMLElement, valueAccessor: any, allBindingsAccessor: any, viewModel: any) => {
//        //expects a single, truthy/falsy binding, 
//        //    such as checked, visible, enable, etc.
//        var binding = valueAccessor();
//        var observable = binding[Object.keys(binding)[0]];
//        var notComputed = ko.computed({
//            read: function () {
//                return !observable();
//            },
//            write: function (newValue) {
//                observable(!newValue);
//            }
//        });
//        var newBinding: any;
//        newBinding[Object.keys(binding)[0]] = notComputed;
//        ko.applyBindingsToNode(element, newBinding, viewModel);
//    }
//};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./Scripts/KnockoutExtensions/bindinghandlers.ts